// File: TopControlPanel.js

import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
    Stack
  } from "@mui/material";
  
  export default function TopControlPanel({
    mode,
    setMode,
    shapeType,
    setShapeType,
    openGlbModal
  }) {
    const isDrawMode = mode === "draw";
  
    return (
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
        {/* Mode Selector */}
        <FormControl component="fieldset">
          <FormLabel component="legend">Mode</FormLabel>
          <RadioGroup
            row
            value={mode}
            onChange={(e) => setMode(e.target.value)}
          >
            <FormControlLabel value="draw" control={<Radio />} label="Draw" />
            <FormControlLabel value="edit" control={<Radio />} label="Edit" />
            <FormControlLabel value="delete" control={<Radio />} label="Delete" />
          </RadioGroup>
        </FormControl>
  
        {/* Shape Type Selector (hidden when draw mode is selected) */}
        {!isDrawMode && (
          <FormControl component="fieldset">
            <FormLabel component="legend">Shape Type</FormLabel>
            <RadioGroup
              row
              value={shapeType}
              onChange={(e) => setShapeType(e.target.value)}
            >
              <FormControlLabel value="zones" control={<Radio />} label="Zones" />
              <FormControlLabel value="geofences" control={<Radio />} label="Geofences" />
              <FormControlLabel value="facilityOutlines" control={<Radio />} label="Facility Outline" />
              <FormControlLabel value="floorPlans" control={<Radio />} label="Floor Plan" />
            </RadioGroup>
          </FormControl>
        )}
  
        {/* Upload GLB Button */}
        <Button variant="contained" onClick={openGlbModal}>
          Upload GLB
        </Button>
      </Stack>
    );
  }
  